import { RootState } from "../../../store";
import { getV2UsersMeSchedulesSelector } from "../workflows/getV2UsersMeSchedulesSelector";

export const schedulesLoadingSelector = (state: RootState) =>
  !!getV2UsersMeSchedulesSelector(state)?.isLoading;
